import type { ApiFilestackImageWithTextData } from '#/api/types/ApiFilestackImageData';
import { FilestackImage } from '#/components/FilestackImage/FilestackImage';
import { useAppConfig } from '#/config/AppConfigContext';
import { imageUrl } from '#/utils/filestack';

import {
  CmsImageBlockImageHolder,
  GifImage,
} from './CmsImageBlockImage.styled';

type Props = {
  image: ApiFilestackImageWithTextData;
  keepDimensions: boolean;
  fullWidthImage: boolean;
  fullWidthLayout: boolean;
};

export function CmsImageBlockImage({
  image,
  keepDimensions,
  fullWidthImage,
  fullWidthLayout,
}: Props) {
  const { appConfig } = useAppConfig();
  const { mimetype, altText } = image;
  const isGif = mimetype === 'image/gif';

  if (isGif) {
    return (
      <GifImage
        src={imageUrl({
          data: image,
          width: undefined,
          height: undefined,
          fit: 'max',
          insecureSVG: false,
          appConfig,
        })}
        alt={altText ?? ''}
        $fullWidthLayout={fullWidthLayout}
      />
    );
  }

  const imageWidth = (() => {
    if (keepDimensions) return;
    return fullWidthImage ? 1920 : 1152;
  })();

  return (
    <CmsImageBlockImageHolder $keepDimensions={keepDimensions}>
      <FilestackImage
        qaId="cms-image-block-image"
        data={image}
        width={imageWidth}
        objectPosition="left"
        allowSVG
      />
    </CmsImageBlockImageHolder>
  );
}
